<template>
  <!-- 个人中心指数分析页面 -->
  <div class="right">
    <div class="dataAny">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="指数" name="first">
          <div id="myChart" style="width: 100%;height: 500px;"></div>
          <div style="width: 94%;border-bottom:1px solid #ccc;margin: 60px;"></div>
          <div id="myChart1" style="width: 100%;height: 600px;"></div>
        </el-tab-pane>
<!--        <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>-->
      </el-tabs>
    </div>
  </div>
</template>

<script>
    import Axios from "axios";
//   import { UserIndex } from '@/request/api'; //指数数据
//   import { UserIndexLine } from '@/request/api'; //曲线数据
	export default {
    metaInfo(){
     return{
        title: '指数分析',
        meta: [
            {
                name: 'keywords',
                content: '驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。'
            },
            {
                name: 'description',
                content:' 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网'
            }
        ]
     }     
    },
		name: 'dataAny',
		data() {
			return {
				msg: "数据分析",
				activeName: 'first',
				options: {
					title: {
						text: '数据详情',
						textStyle: {
							fontWeight: 'normal',
							fontSize: '1em'
						},
						left: '30px'
					},
					tooltip: {
						formatter: ``,
						axisPointer: {
							show: false,
							snap: true,
							trigger: 'axis'
						},
					},  
					legend: {
						data: ['用户指数分析']
					},
					radar: {
						// shape: 'circle',
						name: {
							textStyle: {
								color: '#000',
								//backgroundColor: '#999',
								borderRadius: 3,
								padding: [3, 5]
							}
						},
						indicator: [
							{ name: '内容质量', max: 1000 },
							{ name: '活跃表现', max: 1000 },
							{ name: '领域专注', max: 1000 },
							{ name: '原创能力', max: 1000 },
							{ name: '用户喜爱', max: 1000 }
						]
					},
					series: [{
						name: '账户运营数据',
						type: 'radar',
						//areaStyle: {normal: {}},
						data: [
              {
                value : [55, 33, 44, 55, 66],
                name : '用户指数'
              }
            ]
					}]
				},

				options1: {
					title: {
						text: '历史趋势',
						textStyle: {
							fontWeight: 'normal',
							fontSize: '1em'
						},
						left: '30px'
					},
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: [ '内容质量', '原创能力', '活跃表现', '传播效果', '用户喜爱']
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					toolbox: {
						feature: {
							saveAsImage: {}
						}
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
					},
					yAxis: {
						type: 'value'
					},
					series: [
						{
							name: '内容质量',
							type: 'line',
							stack: '总量',
							data: [220, 182, 191, 234, 290, 330, 310]
						},
						{
							name: '原创能力',
							type: 'line',
							stack: '总量',
							data: [150, 232, 201, 154, 190, 330, 410]
						},
						{
							name: '活跃表现',
							type: 'line',
							stack: '总量',
							data: [320, 332, 301, 334, 390, 330, 320]
						},
						{
							name: '传播效果',
							type: 'line',
							stack: '总量',
							data: [100, 932, 901, 934, 1290, 1330, 1320]
						},
						{
							name: '用户喜爱',
							type: 'line',
							stack: '总量',
							data: [100, 932, 901, 934, 1290, 1330, 1320]
						}
					]
				}
			};
		},
		methods: {
			handleClick(tab, event) {
				////console.log(tab, event);
			},
      //
      GetUserIndex:function(){
            Axios({
      method: "post",
      url: "https://researchadmin.qudong.com/api/user_index/index",
      headers:{
        'token':localStorage.getItem('token')
      },
      params: {
        1:1
      },
    }).then((res) => {
     ////console.log("=222222222222222222222222222222曲线1")
     ////console.log(res);
          var data = [];
          data.push(res.data.data.quality); //内容质量
          data.push(res.data.data.activity); //活跃表现
          data.push(res.data.data.perfect); //领域专注 - 精品能力
          data.push(res.data.data.original); //原创能力
          data.push(res.data.data.user_fav); //用户喜爱
          ////console.log(data);
          this.options.series[0].data[0].value = data;
          ////console.log("=2222222已被重置的数据")
          ////console.log(this.options.series[0].data[0].value);
          ////console.log("=222222222222222222222222222222曲线2")
    });
        //webCommentOneList
        // UserIndex({1:1}).then(res=>{
        //   ////console.log("=222222222222222222222222222222曲线1")
        //   var data = [];
        //   data.push(res.data.quality); //内容质量
        //   data.push(res.data.activity); //活跃表现
        //   data.push(res.data.perfect); //领域专注 - 精品能力
        //   data.push(res.data.original); //原创能力
        //   data.push(res.data.user_fav); //用户喜爱
        //   ////console.log(data);
        //   this.options.series[0].data[0].value = data;
        //   ////console.log("=2222222已被重置的数据")
        //   ////console.log(this.options.series[0].data[0].value);
        //   ////console.log("=222222222222222222222222222222曲线2")
        // }).catch(res=>{
        //   ////console.log("文章列表获取失败222");
        // })
      },
      //获取曲线图数据
      GetUserIndexLine:function(){
           Axios({
      method: "post",
      url: "https://researchadmin.qudong.com/api/user_index/index_line",
      headers:{
        'token':localStorage.getItem('token')
      },
      params: {
        1:1
      },
    }).then((res) => {
       ////console.log("=33333333333333333333333333333333曲线1")
          ////console.log(res.data);
          this.options1.xAxis.data = res.data.data.date;
          this.options1.series[0].data = res.data.data.quality;
          this.options1.series[1].data = res.data.data.original;
          this.options1.series[2].data = res.data.data.activity;
          this.options1.series[3].data = res.data.data.translate;
          this.options1.series[4].data = res.data.data.user_fav;
          //this.options.series[0].data[0].value = data;
          ////console.log("=33333333333333333333333333333333曲线2")
    });
        //webCommentOneList
        // UserIndexLine({1:1}).then(res=>{
        //   ////console.log("=33333333333333333333333333333333曲线1")
        //   ////console.log(res.data);
        //   this.options1.xAxis.data = res.data.date;
        //   this.options1.series[0].data = res.data.quality;
        //   this.options1.series[1].data = res.data.original;
        //   this.options1.series[2].data = res.data.activity;
        //   this.options1.series[3].data = res.data.translate;
        //   this.options1.series[4].data = res.data.user_fav;
        //   //this.options.series[0].data[0].value = data;
        //   ////console.log("=33333333333333333333333333333333曲线2")
        // }).catch(res=>{
        //   ////console.log("文章列表获取失败33333333");
        // })
      },
			drawLine() {
				////console.log("数据图重新加载了")
				// 基于准备好的dom，初始化echarts实例
				let myChart = this.$echarts.init(document.getElementById('myChart'))
				// 绘制图表
				myChart.setOption(this.options);

				let myChart1 = this.$echarts.init(document.getElementById('myChart1'))
				// 绘制图表
				myChart1.setOption(this.options1);
			}
		},
		created() {

		},
    watch: {
      //观察option的变化
      options: {
        handler(newVal, oldVal) {
          if (this.myChart) {
            if (newVal) {
              this.myChart.setOption(newVal);
            } else {
              this.myChart.setOption(oldVal);
            }
          } else {
            this.drawLine();
          }
        },
        deep: true //对象内部属性的监听，关键。
      },
      options1: {
        handler(newVal, oldVal) {
          if (this.myChart) {
            if (newVal) {
              this.myChart.setOption(newVal);
            } else {
              this.myChart.setOption(oldVal);
            }
          } else {
            this.drawLine();
          }
        },
        deep: true //对象内部属性的监听，关键。
      }
    },
		mounted() {
			this.drawLine();
			this.GetUserIndex();
			this.GetUserIndexLine();
		}
	}
</script>

<style scoped>
  .dataAny{ padding: 10px 20px;}
  .right {
    width:980px;
  background: #fff;
}
  body>.el-container {
    margin-bottom: 40px;
  }

  .el-container .el-container {
    width: 80%;
    margin: 0 auto;
  }

  .el-col {
    border-radius: 4px;
  }

  .bg-purple-dark {
    background: #FFF;
    position: relative;
  }

  .ite{
    width: 24%;
    border-right: 1px solid #eee;
    display: inline-block;
  }

  .ite:last-child{
    border: none;
  }

  .ites{
    padding: 2rem 0;
    border-bottom: 1px solid #eee;
  }

  .ite .ite-title{
    width: 100%;
    color: #333;
    text-align: center;
  }

  .ite .ite-title p{
    font-size: 2em;
    font-weight: bold;
  }

  .el-table div{
    text-align: center;
  }

  .bg-purple {
    background: #d3dce6;
  }

  .bg-purple-light {
    background: #e5e9f2;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
 
  .rqxz li{
    float: left;
    margin-right: 20px;
  }
  .rqxz li a{
    color: #409EFF;
  }
  .tips{
    font-size: 15px;
    color: #f83a3a;
  }
  .rqxz .active{
    color: #f83a3a;
  }
  .el-input__inner,.el-button,.el-upload--picture-card{
    border-radius: 0px;
}
.ite-title span{
    font-size: 14px;
    color: #666;
}
.c666{
    color: #666;
}
.rqxz{
    display: table;
    text-align: center;
    margin: 60px auto !important;
    overflow: hidden;
  }
.bg-purple-dark ul li{
    font-size: 16px;
    font-weight: 700;
}
#ite .ite-title p,.ite .ite-title p{
    font-size: 3em !important;
}
</style>